import jsondiffpatch from 'jsondiffpatch';
import utils from './utils';
import jsonStableStringify from 'json-stable-stringify';

export default angular.module('cian.newbuild.filter.filterDiffService', [])
.factory('FilterDiffService', () => {
  // Проверяет, что свойства на втором уровне вложенности
  function contextParentParentIsRoot(context) {
    return context.parent && context.parent.parent && context.parent.parent === context.root;
  }

  return {
    create(filterInfoByKey) {
      // Дополнительные плагины для jsondiffpatch сделаны по примеру описанному здесь
      // https://github.com/benjamine/jsondiffpatch/blob/master/docs/plugins.md
      const diffpatcher = jsondiffpatch.create({
        objectHash(obj) {
          if (!obj.type || !obj.id) {
            return jsonStableStringify(obj);
          }
          return obj.type + obj.id;
        },
      });

      function getDefaultValuesAsUndefinedFilter() {
        // Трактуем значения совпадающие со значениями baseFilter как undefined
        // Пример:
        // defaultValues: {room: null}
        // previousFilter: {room: null}
        // filter: {room: [1,2]}
        // Результат diff'а без этого обработчика: {"room": [null, [1, 2]]}
        // (значение изменилось с null на [1, 2]
        // Результат diff'а c обработчиком: {"room": [[1, 2]]}
        // (новое свойство room со значением [1, 2])
        // https://github.com/benjamine/jsondiffpatch/issues/142
        const defaultValuesAsUndefinedFilter = context => {
          if (contextParentParentIsRoot(context) && context.childName === 'value') {
            const filterInfo = filterInfoByKey[context.parent.childName];
            if (filterInfo) {
              const defaultFilterValue = filterInfo.defaultValue;
              if (context.left === defaultFilterValue) {
                context.left = undefined;
              }
              if (context.right === defaultFilterValue) {
                context.right = undefined;
              }
            }
          }
        };

        defaultValuesAsUndefinedFilter.filterName = 'defaultValuesAsUndefined';
        return defaultValuesAsUndefinedFilter;
      }

      function getFalseValuesAsDefaultFilter() {
        // Трактуем false значения у boolean свойств как значения из baseFilter
        // Пример:
        // previousFilter: {wp: true}
        // filter: {wp: false}
        // Результат diff'а без этого обработчика: {"wp": [true, false]}
        // (значение изменилось с true на false)
        // Результат diff'а c обработчиком: {"wp": [[true, 0, 0]]} (свойство wp было удалено)
        const falseValuesAsDefaultFilter = context => {
          if (contextParentParentIsRoot(context)) {
            const filterInfo = filterInfoByKey[context.childName];
            if (filterInfo) {
              const defaultFilterValue = filterInfo.defaultValue;
              if (context.left.value === true && context.right.value === false) {
                context.right.value = defaultFilterValue;
              }
              if (context.left.value === false && context.right.value === true) {
                context.left.value = defaultFilterValue;
              }
            }
          }
        };

        falseValuesAsDefaultFilter.filterName = 'falseValuesAsDefault';
        return falseValuesAsDefaultFilter;
      }

      function getRangeFilter() {
        // {lte: null, gte: null} -> {lte: 2, gte: null} === Added
        // {lte: 2, gte: null} -> {lte: 2, gte: 5} === Modified
        // {lte: 2, gte: null} -> {lte: '', gte: null} === Deleted
        const rangeFilter = function(context) {
          if (contextParentParentIsRoot(context) && context.childName === 'value') {
            const filterInfo = filterInfoByKey[context.parent.childName];
            if (filterInfo) {
              const type = filterInfo.type;
              const defaultFilterValue = filterInfo.defaultValue;
              if (type === 'range') {
                const [isLeftDefault, isRightDefault] = [
                  utils.rangesAreEqual(context.left, defaultFilterValue),
                  utils.rangesAreEqual(context.right, defaultFilterValue)
                ];

	              if (isLeftDefault) {
		              if (isRightDefault) {
                    context.setResult(undefined)
                  } else {
                    context.setResult([context.right]);
                  }
                } else {
		              if (isRightDefault) {
                    context.setResult([context.left, 0, 0]);
                  } else {
                    if (utils.rangesAreEqual(context.left, context.right)) {
                      context.setResult(undefined);
                    } else {
                      context.setResult([context.left, context.right]);
                    }
                  }
                }
                context.exit();
              }
            }
          }
        };

        rangeFilter.filterName = 'rangeFilter';
        return rangeFilter;
      }

      diffpatcher.processor.pipes.diff.before('trivial', getRangeFilter());
      diffpatcher.processor.pipes.diff.before('trivial', getFalseValuesAsDefaultFilter());
      diffpatcher.processor.pipes.diff.before('trivial', getDefaultValuesAsUndefinedFilter());

      return diffpatcher;
    }
  };
})
.name;



// WEBPACK FOOTER //
// ./src/serp/services/filter-diff.service.js